<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group" style="height: 600px;">
        <div class="col-md-12">
          <table>
            <tbody>
              <tr v-for="(item, index) in comments" :key="index">
                <td class="ts-py-1">
                  <ts-checkbox
                    v-model="item.checked"
                    @change="commentSelected"
                    >{{ item.label }}</ts-checkbox
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'clickComment',
  props: ['value', 'comments'],
  data() {
    return {
      loading: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    commentSelected() {
      if (!_.isEmpty(this.model.comments)) {
        this.model.comments = ''
        this.comments
          .filter(com => com.checked)
          .forEach(com => {
            if (com.checked) {
              this.model.comments =
                this.model.comments + '<p>' + com.label + '</p>'
            }
          })
      } else {
        this.model.comments = ''
        this.comments
          .filter(com => com.checked)
          .forEach(com => {
            if (com.checked) {
              this.model.comments =
                this.model.comments + '<p>' + com.label + '</p>'
            }
          })
      }
    }
  }
}
</script>
